import { render, staticRenderFns } from "./CharSheetCustom.vue?vue&type=template&id=63a818b8&"
import script from "./CharSheetCustom.vue?vue&type=script&lang=js&"
export * from "./CharSheetCustom.vue?vue&type=script&lang=js&"
import style0 from "./CharSheetCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports